export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/service-transport.846ece98-8b8d43.png";